// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card--subtitle__color[data-v-ad800e64] {\n  color: #464855;\n}\n.card--content__color[data-v-ad800e64] {\n  color: #603e99;\n}", ""]);
// Exports
module.exports = exports;
